import React, { useState, useEffect, useContext } from "react";
import { API } from "../common/api-service";
import useFetch from "../../hooks/useFetch";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthContext from "../common/AuthContext";
import { useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { commonFunction } from "../common/common-functions";
import { dataCommonFunction } from "../common/data-common-function";
import { commonVariables } from "../common/common-variables";
import FilesUpload from "../common/FilesUpload";
import FileUploadService from "../common/FileUploadService";
import MyEditor from "../common/MyEditor";
import { WithContext as ReactTags } from "react-tag-input";

// For react-select
const KeyCodes = {
  comma: 188,
  enter: [10, 13],
};
const delimiters = [...KeyCodes.enter, KeyCodes.comma];

export default function PostForm(props) {
  const history = useHistory();
  const location = useLocation();
  const initialState = {
    id: "",
    title: "",
    slug: "",
    category: "",
    body: "",
    notes: "",
    tags: "",
    active: false,
  };
  const [state, setState] = useState(initialState);

  // Sites
  const sites_db = useFetch(`${process.env.REACT_APP_API_URL}/sites/`, "GET");
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const { authState } = useContext(AuthContext);
  const token = authState.token.slice(1, -1);
  const [isChanged, setIsChanged] = useState(false);
  const isDisabled =
    state.title.length === 0 || state.slug.length === 0 || !isChanged;

  // Files
  const [files, setFiles] = useState([]);
  const [savedFiles, setSavedFiles] = useState([]);
  const [deleteSavedFiles, setDeleteSavedFiles] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isCopying, setIsCopying] = useState(false);

  // Tags
  const [tags, setTags] = useState([]);

  const handleChange = (evt) => {
    const value =
      evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
    setIsChanged(true);
  };

  const handleSlugChange = (evt) => {
    const slug = commonFunction.slugify(evt.target.value);
    setState({
      ...state,
      title: evt.target.value,
      slug: slug,
    });
    setIsChanged(true);
  };

  const onSiteChange = (newValue, actionMeta) => {
    setSelectedSite(newValue);
    setState({
      ...state,
      site: newValue.value,
    });
    var link = "get_categories_by_site_id/" + newValue.value.toString() + "/";
    API.getItems(link, token)
      .then((resp) => {
        if (resp.categories && resp.categories.length > 0) {
          const category_options = dataCommonFunction.createSelectOption(
            resp.categories
          );
          setCategories(category_options);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => console.log(error));
    setIsChanged(true);
    console.groupEnd();
  };

  const onCategoryChange = (newValue, actionMeta) => {
    setSelectedCategory(newValue);
    setState({
      ...state,
      category: newValue.value,
    });
    setIsChanged(true);
    console.groupEnd();
  };

  const getUploadedFiles = (list) => {
    setFiles(list);
    setIsChanged(true);
  };

  const getDeleteSavedFile = (file) => {
    var files = deleteSavedFiles;
    files.push(file);
    setDeleteSavedFiles(files);
    setIsChanged(true);
  };

  // Tags
  const handleTagsDelete = (i) => {
    var tagslist = tags.filter((tag, index) => index !== i);
    setTags(tagslist);
    setState({ ...state, tags: commonFunction.connectToList(tagslist) });
    setIsChanged(true);
  };

  const handleTagsAddition = (tag) => {
    var tagslist = tags;
    setTags([...tags, tag]);
    tagslist.push(tag);
    console.log("tagslist", tagslist);
    setState({ ...state, tags: commonFunction.connectToList(tagslist) });
    setIsChanged(true);
  };

  const createClicked = () => {
    var body = state;
    body.category = selectedCategory.value;
    API.createItem("posts", body, token)
      .then((resp) => {
        setProgress(0);
        if (files.length != 0) {
          FileUploadService.upload(
            "post_files",
            files,
            token,
            "post",
            resp.id,
            (event) => {
              const percentage = Math.round((100 * event.loaded) / event.total);
              setProgress(percentage);
              if (percentage == 100) {
                setFiles([]);
              }
            }
          );
        }

        savedFiles.map((sf) => {
          if (deleteSavedFiles.findIndex((df) => df.id === sf.id) == -1) {
            sf.post = resp.id;
            API.callAnAction(
              "copy_post_files",
              sf.id,
              sf,
              "copy_post_file",
              token
            )
              .then((resp2) => {})
              .catch((error) => console.log(error));
          }
        });

        history.push("/posts/");
      })
      .catch((error) => console.log(error));
  };

  const updateClicked = () => {
    // if (location.state && isChanged) {
    if (location.state) {
      API.updateItem("posts", location.state.id, state, token)
        .then((resp) => {
          if (files.length != 0) {
            FileUploadService.upload(
              "post_files",
              files,
              token,
              "post",
              location.state.id,
              (event) => {
                const percentage = Math.round(
                  (100 * event.loaded) / event.total
                );
                setProgress(percentage);
                if (percentage == 100) {
                  setFiles([]);
                }
              }
            );
          }
          if (deleteSavedFiles.length != 0) {
            deleteSavedFiles.map((file) => {
              API.deleteItem("post_files", file.id, token)
                .then((resp2) => {
                  console.log("Deleted files", resp2);
                })
                .catch((error) => console.log(error));
            });
            setDeleteSavedFiles([]);
          }

          history.push("/posts/");
        })
        .catch((error) => console.log(error));
    }
  };

  const onCancel = () => {
    // if (location.state) {
    //   if (location.state.jobid) {
    //     history.push({
    //       pathname: "/jobs/detail/",
    //       state: { id: location.state.jobid },
    //     });
    //   } else {
    //     history.push("/sites/");
    //   }
    // } else {
    //   history.push("/sites/");
    // }
    history.push("/posts/");
  };

  useEffect(() => {
    // Sites
    const site_options = dataCommonFunction.createSelectOption(
      sites_db.response
    );
    setSites(site_options);

    setIsUpdating(false);

    if (location.state) {
      if (location.state.id) {
        var post_id = location.state.id;
        if (location.state.isCopying) {
          setIsUpdating(false);
          setIsCopying(true);
        } else {
          setIsUpdating(true);
        }
        // setIsUpdating(true);
        setIsChanged(false);
        API.getItem("posts", post_id, token)
          .then((resp) => {
            setState((prevState, props) => ({
              id: resp.id,
              title: resp.title,
              slug: resp.slug,
              category: resp.category,
              tags: resp.tags,
              active: resp.active,
              body: resp.body,
              notes: resp.notes,
            }));

            if (resp.tags && resp.tags.length != 0) {
              setTags(commonFunction.splitListToTags(resp.tags));
            }

            var category_id = resp.category;
            API.getItem("categories", category_id, token)
              .then((resp2) => {
                setSelectedSite(
                  site_options.find((element) => {
                    return element.value === resp2.site;
                  })
                );

                var link =
                  "get_categories_by_site_id/" + resp2.site.toString() + "/";
                API.getItems(link, token)
                  .then((resp1) => {
                    if (resp1.categories && resp1.categories.length > 0) {
                      const category_options =
                        dataCommonFunction.createSelectOption(resp1.categories);
                      setCategories(category_options);
                      setSelectedCategory(
                        category_options.find((element) => {
                          return element.value === resp2.id;
                        })
                      );
                    } else {
                      setCategories([]);
                    }
                  })
                  .catch((error) => console.log(error));
              })
              .catch((error) => console.log(error));

            var link = "postfiles/" + resp.id.toString() + "/";
            API.getItems(link, token)
              .then((resp3) => {
                setSavedFiles(resp3.files);
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));
      }
    }
    window.scrollTo(0, 0);
  }, [sites_db.response]);

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Create Post</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Create Post</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="card card-default">
            <div className="card-header">
              <h3 className="card-title">
                {location.state && location.state.id
                  ? "Update Post"
                  : "New Post"}
              </h3>
              <div className="card-tools">
                {location.state &&
                location.state.id &&
                !location.state.isCopying ? (
                  <button
                    className="link-style"
                    style={{ marginLeft: 10, marginRight: 10 }}
                    onClick={updateClicked}
                    // disabled={isDisabled}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    className="link-style"
                    style={{ marginLeft: 10, marginRight: 10 }}
                    onClick={createClicked}
                    disabled={isDisabled}
                  >
                    Create
                  </button>
                )}
                <button
                  className="link-style"
                  style={{ marginLeft: 10, marginRight: 10 }}
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you wish to discard changes?"
                      )
                    )
                      onCancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    {location.state && location.state.id ? (
                      <input
                        id="title"
                        name="title"
                        className="form-control"
                        type="text"
                        placeholder="Enter title"
                        value={state.title}
                        onChange={handleChange}
                      />
                    ) : (
                      <input
                        id="title"
                        name="title"
                        className="form-control"
                        type="text"
                        placeholder="Enter title"
                        value={state.title}
                        onChange={handleSlugChange}
                      />
                    )}
                  </div>
                  <div className="form-group">
                    <label>Site</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedSite}
                      name="site"
                      options={sites}
                      onChange={onSiteChange}
                      placeholder="Select site"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Slug</label>
                    <input
                      id="slug"
                      name="slug"
                      className="form-control"
                      type="text"
                      placeholder="Enter slug"
                      value={state.slug}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Category</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedCategory}
                      name="parent"
                      options={categories}
                      onChange={onCategoryChange}
                      placeholder="Select category"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    <label>Content</label>
                    {/* <textarea
                      className="form-control"
                      id="body"
                      name="body"
                      cols="100"
                      rows="6"
                      defaultValue={state.body}
                      placeholder="Enter content"
                      onChange={handleChange}
                    ></textarea> */}
                    <MyEditor
                      handleChange={(data) => {
                        setState({ ...state, body: data });
                      }}
                      token={token}
                      path="post_files"
                      data={state.body}
                      {...props}
                    />
                    {/* <MyQuill
                      handleChange={(data) => {
                        setState({ ...state, body: data });
                      }}
                      data={state.body}
                      token={token}
                      id="body"
                      name="body"
                    ></MyQuill> */}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Tag</label>
                    <ReactTags
                      id="tag"
                      tags={tags}
                      delimiters={delimiters}
                      handleDelete={handleTagsDelete}
                      handleAddition={handleTagsAddition}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group clearfix">
                    <label>Is active?</label>
                    <div className="icheck-primary d-inline ustorekit-common-margin-10-side">
                      {/* {state.active ? (
                        <input
                          type="checkbox"
                          checked
                          id="active"
                          name="active"
                          onChange={handleChange}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          id="active"
                          name="active"
                          onChange={handleChange}
                        />
                      )} */}
                      <input
                        type="checkbox"
                        checked={state.active}
                        id="active"
                        name="active"
                        onChange={handleChange}
                      />
                      <label htmlFor="active"></label>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    <label>Notes</label>
                    {/* <MyEditor
                      handleChange={(data2) => {
                        setState({ ...state, notes: data2 });
                      }}
                      token={token}
                      path="post_files"
                      data={state.notes}
                      {...props}
                    /> */}
                    <textarea
                      className="form-control"
                      id="notes"
                      name="notes"
                      cols="100"
                      rows="6"
                      defaultValue={state.notes}
                      placeholder="Enter notes"
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Thumbnail</label>
                    <FilesUpload
                      getUploadedFiles={getUploadedFiles}
                      getDeleteSavedFile={getDeleteSavedFile}
                      savedFiles={savedFiles}
                      isUpdating={isUpdating || isCopying}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              {/* <button
                  className="btn btn-info"
                  onClick={updateClicked}
                  disabled={isDisabled}
                >
                  Update
                </button> */}
              {location.state &&
              location.state.id &&
              !location.state.isCopying ? (
                <button
                  className="btn btn-info"
                  onClick={updateClicked}
                  // disabled={isDisabled}
                >
                  Update
                </button>
              ) : (
                <button
                  className="btn btn-info"
                  onClick={createClicked}
                  disabled={isDisabled}
                >
                  Create
                </button>
              )}
              <button
                className="btn btn-default float-right"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you wish to discard changes?")
                  )
                    onCancel();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
